// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"a7d55a6c","667":"67b641d3","726":"23102a5b","978":"574dcdf4"}[chunkId] + ".chunk.js";
};